import { useState, useEffect } from "react";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import Icons from "../../myIcon/Icons";

const editEndpoint = ApiEndpoints.operation.Edit;
const updateEndPoint = ApiEndpoints.operation.Update;

export default function Editperation({ show, onHide, locId }) {
  const location_id = locId;
  const [data, setData] = useState({ name: ""});

  useEffect(() => {
    const dataFetch = async () => {
      try {
        const response = await ApiRequest(
          "GET",
          `${editEndpoint}${location_id}`
        );
        const result = response.department;
        setData(result);
      } catch (error) {
        console.log(error);
      }
    };
    dataFetch();
  }, [location_id]);


  const handleChange = (e) => {
    const { name, value } = e.target;
      setData((prev) => ({
        ...prev,
        department_id: location_id,
        [name]: value,
      }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!data.name) {
      toast.error("All fields are required.");
      return;
    }

    try {
      const response = await ApiRequest("POST", updateEndPoint, data);
      if(response.error === true){
        toast.error(response.message);
      }else {
        toast.success(response.message);
        onHide();
      }

    } catch (error) {
      console.error("Error updating author:", error);
    }
  };

  return (
    <>
      <Modal className="add-modal-area" show={show} onHide={onHide} size="md" aria-labelledby="contained-modal-title-vcenter" centered >
        <Modal.Body>
          <button className="modal-close-button" onClick={onHide}><Icons name="cross" /></button>
          <form onSubmit={handleSubmit}>
            <div className="add-page-sections">Edit Department </div>

            <div className="row">
              <div className="col-md-12">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Department  Name<small>*</small></label>
                  </div>
                  <input name="name" value={data.name} type="text" className="form-control" onChange={handleChange} required />
                </div>
              </div>
            </div>

            <button type="submit" className="default-btn">Save Changes<span></span></button>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
}
